module.exports = __webpack_public_path__ + "static/media/Image_UC2_Personalized_Experience_331_227@2X.81bc75a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/usecases/Image_UC2_Personalized_Experience_331_227@2X.png
// module id = 1270
// module chunks = 0